var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLumError(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "notifications_active"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9998 11C17.9998 7.93 16.3598 5.36 13.4998 4.68V4C13.4998 3.17 12.8298 2.5 11.9998 2.5C11.1698 2.5 10.4998 3.17 10.4998 4V4.68C7.62979 5.36 5.99979 7.92 5.99979 11V16L3.99979 18V19H19.9998V18L17.9998 16V11ZM6.14979 2.65L7.57979 4.08C5.53979 5.53 4.17979 7.85 4.02979 10.5H2.02979C2.16979 7.3 3.74978 4.48 6.14979 2.65ZM21.9698 10.5H19.9698C19.8198 7.85 18.4498 5.53 16.4298 4.08L17.8498 2.65C20.2398 4.48 21.8198 7.3 21.9698 10.5ZM12.3998 21.96C12.2698 21.99 12.1398 22 11.9998 22C10.8898 22 9.99979 21.1 9.98979 20H13.9898C13.9898 20.28 13.9398 20.54 13.8398 20.78C13.5798 21.38 13.0498 21.82 12.3998 21.96Z",
    fill: "#CA3C3D"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLumError);
export default __webpack_public_path__ + "static/media/lumError.037e5b5410982d223eaf3236007dd3e3.svg";
export { ForwardRef as ReactComponent };